// extracted by mini-css-extract-plugin
export default {"Links":"styles_Links__-INnx"};